import { DataService } from 'src/app/services/data.service';
import { FormGroup } from '@angular/forms';
import { User, UserType } from './../../../../../interfaces/user';
import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';

@Component({
  selector: 'app-super-admin-admins',
  templateUrl: './super-admin-admins.component.html',
  styleUrls: ['./super-admin-admins.component.scss']
})
export class SuperAdminAdminsComponent implements OnInit {

  UserType = UserType;

  admins: User[];

  form: FormGroup;

  constructor(
    private data: DataService
  ) { }

  ngOnInit() {
    this.getData();
  }

  getData(){
    this.data.getUsers({
      type: [UserType.SchoolAdmin, UserType.SuperAdmin].join(',')
    }).subscribe((res) => {
      if(res && res.data){
        this.admins = res.data;
      }
    })
  }

  async deleteAdmin(id: string){
    this.data.updateAdminUser(id, {type: UserType.UnApprovedTeacher}).subscribe((res) => {
      if(res){
        this.getData();
      }
    })
  }

  async addAdmin(){
    swal.fire({
      title: 'Enter user\'s ID',
      input: 'text',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'You need to write something!'
        }
      },
      showLoaderOnConfirm: true,
      preConfirm: (id) => {
        return this.data.addAdmin({userid: id}).toPromise()
          .catch(error => {
            swal.showValidationMessage(error)
          })
      },
      allowOutsideClick: () => !swal.isLoading()
    }).then(() => {
      this.getData()
    })
  }
}
